import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useConfig } from 'builder/hooks/useConfig'
import { selectors, ResumeFieldSuggest } from 'builder/modules/resumeEditor'
import useImproveResumePanel from '../ImproveResumePanel/hooks/useImproveResumePanel'
import { SuggestionBadge } from './SuggestionBadge'

type Props = {
  sectionName: string
}

export const SectionSuggestionBadge = ({ sectionName }: Props) => {
  const config = useConfig()
  const { suggestions } = useTypedSelector(selectors.scoreSuggestions)
  const { getSuggestionScore } = useImproveResumePanel()

  const sectionSuggestion = suggestions.find((suggestion: ResumeFieldSuggest) => {
    if (suggestion.type === 'section' && suggestion.sectionName === sectionName) {
      return true
    }
    // Special case: render simpleField suggestions for profile section as section badges
    if (
      sectionName === 'profile' &&
      suggestion.type === 'simpleField' &&
      suggestion.fieldId === 'profile'
    ) {
      return true
    }
    return false
  })

  if (!sectionSuggestion || !config?.features.isNewBuilderEnabled) {
    return null
  }

  const score = getSuggestionScore(sectionSuggestion)

  return <SuggestionBadge suggestion={sectionSuggestion} score={score} />
}
